/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {StateMatrix} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";

export class TransformNinjaWildsPresentation implements SimplePresentation {
    name:string = "TransformWildsPresentation";
    private roundIndex:number;
    private winInfo:AvalancheWinInfo;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        return KitchenDramaSushiMania.model.gameData.overlayWilds[this.roundIndex] != null;
    }

    start(controller:SimplePresentationRunnerController):void {
        const wildTransformPositions = StateMatrix.tuples2Coords(KitchenDramaSushiMania.model.gameData.overlayWilds[this.roundIndex]);


        const initialNinjaJumps = [];
        const transformAnimations = [];
        for (let transformPos of wildTransformPositions){
            const swapData = KitchenDramaSushiMania.reelView.transformSymbolAt(transformPos.column, transformPos.row, "W2");
            (<KitchenDramaSushiManiaSymbol>swapData.newSymbol.positionable).transformHide(0);

            if (swapData.oldSymbol.name == "W"){
                const initJumpTl = gsap.timeline();
                initJumpTl.add((<KitchenDramaSushiManiaSymbol>swapData.oldSymbol.positionable).playNinjaInit());
                initialNinjaJumps.push(initJumpTl);
            }

            const transformTl = gsap.timeline();
            transformTl.add((<KitchenDramaSushiManiaSymbol>swapData.newSymbol.positionable).transformToNinjaWild());
            transformTl.add((<KitchenDramaSushiManiaSymbol>swapData.oldSymbol.positionable).transformHide(0.1), "<1.0");

            transformTl.add(()=>{
                KitchenDramaSushiMania.reelView.removeSymbol(swapData.oldSymbol);
            });

            transformAnimations.push(transformTl);

        }

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});


        const initialJump = GSAPUtils.createTimelineFromArray(initialNinjaJumps, 0);
        initialJump.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.WILD_JUMP.next()), 0.1);

        const transformTl = GSAPUtils.createTimelineFromArray(transformAnimations, 0);
        transformTl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.WILD_LANDING), 0.8);

        tl.add([
            initialJump,
            KitchenDramaSushiMania.ninjaSplashView.show()
        ]);
        tl.add(transformTl);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.WILD_SPLIT), "<-0.2");

    }
}